import { useLocation } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { OverviewTabFallback } from '@/routes/database/tabs/overview/fallback'

export const DatabasePageFallback = () => {
  const location = useLocation()

  if (location.pathname.includes('/overview')) {
    return <OverviewTabFallback />
  }

  return <CardSkeleton />
}
